import React from 'react'
import {Link} from 'gatsby'
import PropTypes from 'prop-types'
import tw from 'twin.macro'

const TocContainer = tw.div`lg:sticky lg:top-0 bg-gray-300 lg:bg-transparent p-4 lg:p-0 rounded-lg`
const TocHeading = tw.h3`font-bold mt-4`
const TocLinkBase = tw(Link)`block text-ql-gray hover:text-ql-blue focus:text-ql-blue`
const TocTitle = tw.h2`mb-4 text-sm uppercase`

const TocLink = (props) => (
  <TocLinkBase
    {...props}
    partiallyActive
    activeStyle={tw`font-bold text-ql-blue tracking-wide`}
  />
)

const DocToc = ({toc}) => (
  <TocContainer>
    <TocTitle>Contents</TocTitle>
    {toc.map(section => (
      <div key={section.title}>
        <TocHeading>{section.title}</TocHeading>
        <ul>
          {section.links.map(link => <TocLink key={link.node.id} to={`/docs/${link.node.frontmatter.slug}`}>{link.node.frontmatter.title}</TocLink>)}
        </ul>
      </div>
    ))}
  </TocContainer>
)

DocToc.propTypes = {
  toc: PropTypes.array
}

export default DocToc
